import { vueConfig } from '../js/configs'

import 'bootstrap/dist/css/bootstrap.min.css'
import '../vendors/all.min.css' // Font Awesome Free 5.15.4
import '~templates/css/icomoon/style.css' // Icomoon
import '~templates/css/style.css'

import 'intersection-observer'

import $ from 'jquery'
window.$ = $
window.jQuery = $

import 'popper.js'
import 'bootstrap/js/dist/util'
import 'bootstrap/js/dist/modal'
import 'bootstrap/js/dist/tooltip'
import 'bootstrap/js/dist/dropdown'
import 'bootstrap/js/dist/popover'
import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/dist/carousel'
import 'bootstrap/js/dist/tab'
import 'bootstrap/js/dist/alert'
import 'bootstrap/js/dist/button'

import Vue from 'vue'

import './utils/polyfills'

window.app = new Vue(vueConfig)
